const UTM_MEDIUM = 'utm_medium';
const UTM_CAMPAIGN = 'utm_campaign';

const utmTags = {
  [UTM_MEDIUM]: {
    linkedin: 'linkedin',
    wechat: 'wechat',
    email: 'job floating'
  },
  [UTM_CAMPAIGN]: {
    jobs: 'marketing',
    auto_job_float: 'automated'
  }
};

export default {
  getApplicationCreatedSource(query) {
    if (query.referral_code) {
      return 'job referral';
    }

    if (query[UTM_MEDIUM]) {
      let source = this.getSourceByUTMTag(UTM_MEDIUM, query[UTM_MEDIUM]);
      if (query[UTM_MEDIUM] === 'email' && query[UTM_CAMPAIGN]) {
        source += ` (${this.getSourceByUTMTag(UTM_CAMPAIGN, query[UTM_CAMPAIGN])})`;
      }
      return source;
    }

    return 'organic';
  },
  getSourceByUTMTag(tag, value) {
    let tags = utmTags[tag];

    if (value) {
      return tags[value.toLowerCase()] ? tags[value.toLowerCase()] : value;
    }
  }
};
